module.exports = __webpack_public_path__ + "img/videortc.095f9abd.png";